import { axiosInstance } from './axiosInstance';

export const getTeamMembers = (user) => {
    return axiosInstance.get(`team/get_team_members`, {
        params: {
            user: user,
        },
    });
};
